import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ConfirmationNumIcon(props: IconProps) {
    return <Icon {...props} iconKey={"confirmation_num"}/>
}
